import { render, staticRenderFns } from "./or_gdh_report.vue?vue&type=template&id=427f2014&scoped=true"
import script from "./or_gdh_report.vue?vue&type=script&lang=js"
export * from "./or_gdh_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f2014",
  null
  
)

export default component.exports